/**
 * Is this `/projects/:id` segment a real project id?
 *
 * `/projects/new` matches the very same `/projects/:id/*` pattern the project
 * screens use, so react-router hands back `id === "new"`. The create wizard has
 * no project yet, so mounting the project chrome for it renders a SowHeader and
 * top-nav whose links point at a project that does not exist, and fires
 * useV2GetProjectByIdQuery("new") against the API.
 *
 * Project ids are always numeric (v2 returns them as strings, but still
 * numeric), so anything else is a literal route segment like "new".
 */
const isProjectId = (segment: string | undefined): boolean =>
  !!segment && /^\d+$/.test(segment);

export default isProjectId;
